/**
 * These are technically the old (pre-Project InIt) colors.
 */
export const btmColors = {
    white: '#FFFFFF',
    black: '#000000',
    blue: '#0079C1',
    /**
     * BTM Secondary colors.
     */
    navy: '#00355E',
    green: '#BDCC2A',
    /**
     * BTM complimentary colors.
     */
    orange: '#F8981D',
    purple: '#95358C',
    /**
     * Cool gray 11 is used for type that is not reversed out (except for patient materials, which have 100% black text).
     */
    cool_gray: '#55565B',

    /**
     * BTM extended palette colors. These (teal) should only be used if more than 5/6 colors is required for visibility/accessibility.
     */
    dark_teal: '#009CA7',
    light_teal: '#87DADF',
    /**
     * Misc Colors found in apps
     */
    warning: '#f8981d',
    error: '#d0021b',
    primaryText: '#333',
    lightBlue: '#f6f9fc',
    gray: '#586c78',
    almostGray: '#F7F7F7',

    /**
     * BTM B2B Brand Colors
     */
    b2b_blue: '#005cb9',
    b2b_green: '#b4bd00',
    b2b_gray: '#54565a',

    // neutral palette colors from prelim web style guide
    whisper: '#EEEEEE',
    quartz: '#DDDDDE',
    spunPearl: '#AAAAAD',
    manatee: '#88888C',
    brightGray: '#55565B',
};

/**
Night #00355E
Morning #0079C1
Dayglow #BDCC2A
Plum #8A2066
Supporting colors: Red #B00020, Orange #EB7100, Teal #19A38A, Purple #4D3CA0
Admin → Settings → set up new Default Visualization Colors, delete BTM Colors?
NMDP Color collection -
Morning, Dayglow, Plum,    Teal,    Orange,  Purple,  Red,     Night
#0079C1, #BDCC2A, #8A2066, #19A38A, #EB7100, #4D3CA0, #B00020, #00355E
Gradient - night
#CCE9FF,  #0079C1 , #00355E
Diverging - orange, white, night
#EB7100, #F5B880, #FFFFFF, #0079C1, #00355E
Dashboard headers - text tiles and in LookML
Color notes
Headers, main text - use Night
Visualizations - use in order of color palette (less Night - colorblind can't distinguish between Night and Plum)
 */
